import { render, staticRenderFns } from "./SelectLocale.vue?vue&type=template&id=5f6effac&scoped=true&"
import script from "./SelectLocale.vue?vue&type=script&lang=js&"
export * from "./SelectLocale.vue?vue&type=script&lang=js&"
import style0 from "./SelectLocale.vue?vue&type=style&index=0&id=5f6effac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6effac",
  null
  
)

export default component.exports